import { instanceOEF, segundaVersaoOEF } from './api'

export const listaCartoes = () => instanceOEF.get( `${segundaVersaoOEF}/cartoes-credito` )

export const deletaCartao = cartao => instanceOEF.delete( `/cartoes-credito`, { 'data': cartao } )

export const cadastraCartao = cartao => instanceOEF.post( `${segundaVersaoOEF}/cartoes-credito`, cartao )

export const cadastraCartaoVigente = cartao => instanceOEF.patch( `${segundaVersaoOEF}/assinatura`, cartao )

export const postAutoCobranca = ( CVV, assinaturaId ) => instanceOEF.post(
  `${segundaVersaoOEF}/cobrar`,
  {
    'assinatura_id': assinaturaId,
    'cvv': CVV,
    'origem': 'COBRANCA_MANUAL_ASSOCIADO'
  }
)
